/* Campaña Cyber Monday: cuenta regresiva a una fecha fija, fila fija al bajar y fin automático. */
(function () {
  if (window.__ednCyber) return;
  window.__ednCyber = true;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function hideAll() {
    document.querySelectorAll('[data-edn-cyber]').forEach(function (e) { e.remove(); });
  }

  function tick() {
    var left = 0;
    document.querySelectorAll('[data-edn-cyber-timer]').forEach(function (t) {
      left = Math.max(0, parseInt(t.getAttribute('data-edn-cyber-timer'), 10) - Math.floor(Date.now() / 1000));
      t.querySelector('[data-h]').textContent = pad(Math.floor(left / 3600));
      t.querySelector('[data-m]').textContent = pad(Math.floor(left / 60) % 60);
      t.querySelector('[data-s]').textContent = pad(left % 60);
    });
    var el = document.querySelector('[data-edn-cyber]');
    if (el && Math.floor(Date.now() / 1000) >= parseInt(el.getAttribute('data-end'), 10)) { hideAll(); clearInterval(timer); }
  }

  function initSticky() {
    var ph = document.querySelector('.ecy-ph'), row = document.querySelector('.ecy-row');
    if (!ph || !row) return;
    var fixed = false, queued = false;
    function check() {
      queued = false;
      var f = ph.getBoundingClientRect().top <= 0;
      if (f === fixed) return;
      fixed = f;
      ph.style.height = f ? row.offsetHeight + 'px' : '';
      row.classList.toggle('is-fixed', f);
      document.documentElement.style.setProperty('--ecy-row-h', f ? row.offsetHeight + 'px' : '0px');
    }
    function req() { if (!queued) { queued = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req);
    check();
  }

  var timer = setInterval(tick, 1000);
  function start() { tick(); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
